<div class="dialog">
  @if (isMobileView()) {
    <header class="mobile-app-bar sticky-header">
      <p (click)="close()" class="task-header-action" translate>Cancel</p>
      <h2 class="mobile-app-bar__heading">Faq {{ (currentFaq ? 'Edit' : 'Add') | translate | lowercase }}</h2>
      <p class="task-header-action disabled" disabled="true" translate>Save</p>
    </header>
  }

  @if (!isMobileView()) {
    <header class="dialog__header">
      <h3 class="dialog__header__title">{{ 'Faq' | translate }} {{ (currentFaq ? 'Edit' : 'Add') | translate | lowercase }}</h3>
      <div class="dialog__header__action-buttons">
        <div (click)="close()" class="dialog__header__action-buttons__button">
          <span>
            <app-icon [cssStyle]="{ 'margin-top': '3px' }" iconName="close" size="14px"></app-icon>
          </span>
        </div>
      </div>
    </header>
  }

  <div class="dialog__content">
    <form [formGroup]="form" action="" class="form">
      <!-- Image Selector -->
      <div class="input-group">
        <label for="image" translate>Attachment</label>
        <app-image-selector
          (imageSelected)="selectedImage = $event"
          [allowDocument]="true"
          [aspectRatio]="4 / 3"
          [entityId]="faqId"
          [fullWidthPreview]="true"
          [imageCropper]="true"
          [isUpdateMode]="isUpdateMode"
          [sectionType]="SectionType.FAQ"
          formControlName="image"
          id="image"
          name="image"
        ></app-image-selector>
        <!--        <app-form-error [control]="form.get('image')" [name]="'Image' | translate"></app-form-error>-->
      </div>

      <!-- Title -->
      <div class="input-group --required">
        <label for="title" translate>Title</label>
        <input [placeholder]="'Enter Title' | translate" class="full-width-input" formControlName="title" id="title" name="title" type="text" />
        <app-form-error [control]="form.get('title')" [name]="'Title' | translate"></app-form-error>
      </div>

      <!-- Category -->
      <div class="input-group --required">
        <label for="category" translate>Category</label>
        <app-dropdown [options]="categories" bindValue="id" displayName="title" formControlName="category" id="category" name="category"></app-dropdown>
        <app-form-error [control]="form.get('category')" [name]="'Category' | translate"></app-form-error>
      </div>

      <!-- Position -->
      <div class="input-group --required">
        <label for="position" translate>Position</label>
        <app-dropdown [options]="positions" formControlName="position" id="position" name="position"></app-dropdown>
        <app-form-error [control]="form.get('position')" [name]="'Position' | translate"></app-form-error>
      </div>

      <!--      <ng-container *ngIf="currentFaq">-->
      <!--        <div class="input-group">-->
      <!--          <label for="position2" translate>Position</label>-->
      <!--          <app-dropdown [disabled]="true" [options]="positions" formControlName="position" id="position2" name="position2"></app-dropdown>-->
      <!--        </div>-->
      <!--      </ng-container>-->
      <!-- Description -->
      <div class="input-group --required">
        <label for="description" translate>Description</label>
        <textarea [placeholder]="'Enter Description' | translate" class="full-width-input" formControlName="description" id="description" name="description" rows="3"></textarea>
        <app-form-error [control]="form.get('description')" [name]="'Description' | translate"></app-form-error>
      </div>
    </form>
  </div>

  <footer>
    <div class="dialog__footer">
      @if (!isMobileView()) {
        <div class="dialog__footer__buttons">
          <app-button (click)="close()" [idleText]="'Cancel' | translate" [inlineStyle]="{ border: '1px solid var(--gray)' }" cssClass="button-simple"></app-button>
          <app-button (clickEvent)="save($event)" [disabled]="form.pristine" [idleText]="(currentFaq ? 'Update' : 'Save') | translate"></app-button>
        </div>
      }
    </div>
    @if (isMobileView()) {
      <div class="mobile-button">
        <app-button (clickEvent)="save($event)" [disabled]="form.pristine" [idleText]="(currentFaq ? 'Update' : 'Save') | translate" cssClass="button-primary button-full"></app-button>
      </div>
    }
  </footer>
</div>
